export default "skymp5-front/06a298c40e1d6dc99a81d63276ee6161.svg";